import React from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';

import AuthenticatedRoute from './hoc/AuthenticatedRoute';
import Admin from './pages/Admin';
import ResetPassword from './pages/ResetPassword';
import Login from './pages/staff-login/Login';

function Routes() {
  return (
    <BrowserRouter>
      <Switch>
        {/* <Route path="/" exact component={login} /> */}
        <Route path="/request-password-reset" component={ResetPassword} />
        <Route
          path="/login"
          exact
          render={(props) => {
            return <Login {...props} />;
          }}
        />
        <Route
          path="/"
          render={(props) => {
            return <AuthenticatedRoute Component={Admin} {...props} />;
          }}
        />
      </Switch>
    </BrowserRouter>
  );
}

export default Routes;
